import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteObjektNutzungCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteObjektNutzungCommandService],
  exports: []
})
export class DeleteObjektNutzungCommandServiceModule { }
